module.exports = __webpack_public_path__ + "static/img/game-logo-xpg.d657159.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-xpg.png
// module id = noS4
// module chunks = 0 1 2 3 4 5 6